//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Command } from "ckeditor5";

const DEFAULT_INSERT_TYPE = "csv";
const INSERT_TYPES = ["csv"];

class ResponseCategoryCommand extends Command {
  constructor(editor) {
    super(editor);
    this.set({
      insertType: DEFAULT_INSERT_TYPE,
      categoryName: null,
    });
  }

  execute(options) {
    let executeOptions;
    if (!options) {
      if (!this.value) {
        return;
      }

      executeOptions = {
        insertType: this.insertType,
        categoryId: this.value,
        categoryName: this.categoryName,
      };
    } else {
      executeOptions = Object.assign({}, options);
    }
    if (!executeOptions.categoryName) {
      executeOptions.categoryName = this.editor.config.get("responseCategory.emptyCategoryName");
    }
    const model = this.editor.model;
    model.change((writer) => {
      const category = writer.createElement("responseCategory", executeOptions);
      model.insertContent(category);
      writer.setSelection(category, "on");
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;
    const element = selection.getSelectedElement();
    if (element && element.is("element", "responseCategory")) {
      this.isEnabled = true;
      this.insertType = element.getAttribute("insertType");
      this.value = element.getAttribute("categoryId");
      this.categoryName = element.getAttribute("categoryName");
    } else {
      const allowedIn = model.schema.findAllowedParent(
        selection.getFirstPosition(),
        "responseCategory",
      );

      this.isEnabled = !!allowedIn;
      this.insertType = DEFAULT_INSERT_TYPE;
      this.value = "";
      this.categoryName = "";
    }
  }
}

export { DEFAULT_INSERT_TYPE, INSERT_TYPES, ResponseCategoryCommand };
